var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo } from '@ember-data/model';
let DescriptionModelCommon = (_dec = attr(), _dec2 = attr(), _dec3 = attr(), _dec4 = attr(), _dec5 = attr(), _dec6 = attr(), _dec7 = attr(), _dec8 = attr(), _dec9 = attr(), _dec0 = attr(), _dec1 = belongsTo('product', {
  async: true
}), _class = class DescriptionModelCommon extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "goals", _descriptor, this);
    _initializerDefineProperty(this, "public", _descriptor2, this);
    _initializerDefineProperty(this, "prerequisite", _descriptor3, this);
    _initializerDefineProperty(this, "technicalRequirement", _descriptor4, this);
    _initializerDefineProperty(this, "practicalities", _descriptor5, this);
    _initializerDefineProperty(this, "price", _descriptor6, this);
    _initializerDefineProperty(this, "formation", _descriptor7, this);
    _initializerDefineProperty(this, "keyStrengths", _descriptor8, this);
    _initializerDefineProperty(this, "program", _descriptor9, this);
    _initializerDefineProperty(this, "formator", _descriptor0, this);
    _initializerDefineProperty(this, "product", _descriptor1, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "goals", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "public", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "prerequisite", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "technicalRequirement", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "practicalities", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "formation", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "keyStrengths", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "program", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "formator", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "product", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DescriptionModelCommon as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.